export default __webpack_public_path__ + "static/media/Group 754.fae2e624.jpg";